/**
 * Do not edit directly
 * Generated on Fri, 24 Nov 2023 05:18:02 GMT
 */
const DZ_COLOR_NEUTRAL_100 = "#EFEFEF";
const DZ_COLOR_NEUTRAL_200 = "#B5B5B5";
const DZ_COLOR_NEUTRAL_300 = "#7E7E7E";
const DZ_COLOR_NEUTRAL_400 = "#616161";
const DZ_COLOR_NEUTRAL_500 = "#000000";
const DZ_COLOR_NEUTRAL_000 = "#FFFFFF";
const DZ_COLOR_PURPLE_100 = "#E6D2FB";
const DZ_COLOR_PURPLE_200 = "#CDB9E6";
const DZ_COLOR_PURPLE_300 = "#B287DF";
const DZ_COLOR_PURPLE_400 = "#8F63BC";
const DZ_COLOR_PURPLE_500 = "#6E3FA3";
const DZ_COLOR_GREEN_100 = "#BFF5DD";
const DZ_COLOR_GREEN_200 = "#9BD7BE";
const DZ_COLOR_GREEN_300 = "#00AE73";
const DZ_COLOR_GREEN_400 = "#008B5C";
const DZ_COLOR_GREEN_500 = "#00573C";
const DZ_COLOR_PINK_100 = "#FFDFE1";
const DZ_COLOR_PINK_200 = "#FFC8CD";
const DZ_COLOR_PINK_300 = "#FEB4BF";
const DZ_COLOR_PINK_400 = "#FC9BB3";
const DZ_COLOR_PINK_500 = "#C80058";
const DZ_COLOR_YELLOW_100 = "#FFF3BF";
const DZ_COLOR_YELLOW_200 = "#FFE67F";
const DZ_COLOR_YELLOW_300 = "#FDDD00";
const DZ_COLOR_YELLOW_400 = "#FFCE00";
const DZ_COLOR_YELLOW_500 = "#F2A900";
const DZ_COLOR_ORANGE_40 = "#FFF5E9";
const DZ_COLOR_ORANGE_200 = "#FFE6C7";
const DZ_COLOR_ORANGE_300 = "#FFB194";
const DZ_COLOR_ORANGE_400 = "#FF4713";
const DZ_COLOR_RED_100 = "#FFEBE5";
const DZ_COLOR_RED_200 = "#F97070";
const DZ_COLOR_RED_300 = "#E40509";
const DZ_COLOR_RED_400 = "#CC0018";
const DZ_COLOR_RED_500 = "#990012";
const DZ_COLOR_BLK_PURPLE = "#8F63BC";
const DZ_COLOR_BLK_GREEN = "#008B5C";
const DZ_COLOR_BLK_PINK = "#FC9BB3";
const DZ_COLOR_BLK_YELLOW = "#FFCE00";
const DZ_COLOR_BLK_ORANGE = "#FF4713";
const DZ_COLOR_BLK_RED = "#CC0018";
const DZ_COLOR_BLK_WHITE = "#FFFFFF";
const DZ_COLOR_BLK_BLACK = "#000000";
const DZ_COLOR_SUCCESS = "#008B5C";
const DZ_COLOR_WARNING = "#FFCE00";
const DZ_COLOR_ERROR = "#CC0018";
const DZ_COLOR_OUTLINE = "#0A6DC2";

/**
 * Generated bundle index. Do not edit.
 */

export { DZ_COLOR_BLK_BLACK, DZ_COLOR_BLK_GREEN, DZ_COLOR_BLK_ORANGE, DZ_COLOR_BLK_PINK, DZ_COLOR_BLK_PURPLE, DZ_COLOR_BLK_RED, DZ_COLOR_BLK_WHITE, DZ_COLOR_BLK_YELLOW, DZ_COLOR_ERROR, DZ_COLOR_GREEN_100, DZ_COLOR_GREEN_200, DZ_COLOR_GREEN_300, DZ_COLOR_GREEN_400, DZ_COLOR_GREEN_500, DZ_COLOR_NEUTRAL_000, DZ_COLOR_NEUTRAL_100, DZ_COLOR_NEUTRAL_200, DZ_COLOR_NEUTRAL_300, DZ_COLOR_NEUTRAL_400, DZ_COLOR_NEUTRAL_500, DZ_COLOR_ORANGE_200, DZ_COLOR_ORANGE_300, DZ_COLOR_ORANGE_40, DZ_COLOR_ORANGE_400, DZ_COLOR_OUTLINE, DZ_COLOR_PINK_100, DZ_COLOR_PINK_200, DZ_COLOR_PINK_300, DZ_COLOR_PINK_400, DZ_COLOR_PINK_500, DZ_COLOR_PURPLE_100, DZ_COLOR_PURPLE_200, DZ_COLOR_PURPLE_300, DZ_COLOR_PURPLE_400, DZ_COLOR_PURPLE_500, DZ_COLOR_RED_100, DZ_COLOR_RED_200, DZ_COLOR_RED_300, DZ_COLOR_RED_400, DZ_COLOR_RED_500, DZ_COLOR_SUCCESS, DZ_COLOR_WARNING, DZ_COLOR_YELLOW_100, DZ_COLOR_YELLOW_200, DZ_COLOR_YELLOW_300, DZ_COLOR_YELLOW_400, DZ_COLOR_YELLOW_500 };
